import React, { useEffect, useState } from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import Slider from "react-slick";
import "../../sass/slick/slick.min.scss";
import "../../sass/slick/slick-theme.min.scss";
import '../../sass/components/flexibleModules/_components.featuredSolutionsComponent.scss';

const FeaturedSolutionsComponent = ({ data }) => {

    const [isRendered, setIsRendered] = useState(false);

    let settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        draggable: false,
        centerMode: false,
        swipeToSlide: true,
        centerPadding: '60px 0 0',
        touchThreshold: 250,
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 2,
                    centerPadding: '40px',
                }
            },
            {
                breakpoint: 620,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    centerPadding: '0',
                }
            }
        ]
    };

    useEffect(() => {
        setIsRendered(true);
    }, []);

    return (
        <div className="cp-featuredSolutionsComponent" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-featuredSolutionsComponent__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                {data.featuredSolutionsHeader &&
                    <h2 dangerouslySetInnerHTML={{ __html: data.featuredSolutionsHeader }} />
                }
                {data.featuredSolutionsTeaser &&
                    <p dangerouslySetInnerHTML={{ __html: data.featuredSolutionsTeaser }} />
                }
                {data.featuredSolutionsButton &&
                    <div className="l-relativeButton">
                        <a href={data.featuredSolutionsButton.url} target={data.featuredSolutionsButton.target} className="l-button">
                            <span>{data.featuredSolutionsButton.title}</span>
                            <StaticImage src="../../images/arrow-right-white.svg" alt="" />
                        </a>
                        <a href={data.featuredSolutionsButton.url} target={data.featuredSolutionsButton.target} className="l-button l-backgroundHover">
                            <span>{data.featuredSolutionsButton.title}</span>
                            <StaticImage src="../../images/arrow-right-white.svg" alt="" />
                        </a>
                    </div>
                }
                {data.featuredSolutionsSections &&
                    <div className="cp-featuredSolutionsComponent__sections">
                        {isRendered &&
                            <Slider {...settings}>
                                {data.featuredSolutionsSections.map((section, index) => (
                                    <a href={section.link.url} target={section.link.target} className="cp-featuredSolutionsComponent__section" key={index}>
                                        <div>
                                            {section.image &&
                                                <GatsbyImage image={getImage(section.image.gatsbyImage)} alt={section.image.altText} />
                                            }
                                            {section.title &&
                                                <h3>{section.title}</h3>
                                            }
                                            {section.teaser &&
                                                <p dangerouslySetInnerHTML={{ __html: section.teaser }} />
                                            }
                                        </div>
                                        {section.link &&
                                            <span className="l-textlink">{section.link.title}</span>
                                        }
                                    </a>
                                ))}
                            </Slider>
                        }
                    </div>
                }
            </div>
        </div>
    )
}

export default FeaturedSolutionsComponent;